import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Card from "../components/Card";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[var(--bg-main)]">
      <Sidebar />
      <div className="flex-1 p-4 md:p-8 md:ml-64">
        <div className="mb-6">
          <button
            onClick={() => navigate("/settings")}
            className="mb-4 px-4 py-2 rounded-lg bg-surface-soft text-[var(--text-primary)] hover:bg-surface-soft transition-all"
          >
            Back to Settings
          </button>
          <h1 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-[#22c55e] to-[#16a34a] bg-clip-text text-transparent">
            About
          </h1>
          <p className="text-[var(--text-primary)] text-sm md:text-base">
            Overview of the Aiarbix platform and product mission.
          </p>
        </div>

        <Card>
          <div className="space-y-4 text-[var(--text-primary)] text-sm">
            <p>
              This platform provides wallet management, arbitrage tracking,
              staking visibility, and referral network insights.
            </p>
            <p>
              The dashboard is built to present real-time account and trading
              data with secure access controls.
            </p>
            <p>
              Version updates focus on data accuracy, compliance flows, and
              improved user experience.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default About;
